import { bankServices } from "../../config/axios";
import {
    DELETE_USERDETAILS_SUCCESS,
    DELETE_USERDETAILS_FAILED,
    RESET_DELETE_USERDETAILS,
    LOADING_DELETE_USERDETAILS,
    DELETE_USERDETAILS_NETWORKERROR
} from '../types/index';

const resetdeleteUserManagement = () => {
    return { type: RESET_DELETE_USERDETAILS };
};

const deleteUserManagement = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DELETE_USERDETAILS });
    await bankServices
        .post("getDeleteUserDetaisList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(success(res.data));
                    break;
                default:
                    dispatch(failed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: DELETE_USERDETAILS_NETWORKERROR,
                payload: err
            });
        });
}

function success(data) {
    return {
        type: DELETE_USERDETAILS_SUCCESS,
        payload: data
    };
}
function failed(data) {
    return {
        type: DELETE_USERDETAILS_FAILED,
        payload: data
    };
}

export { resetdeleteUserManagement, deleteUserManagement }